// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-section {
  width: 100%;
  height: var(--headerHeight);
  background-color: var(--indigo-1000);
  z-index: 50;
  padding: 0.5rem 2.375rem 1rem;
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.header-section .header-wrap {
  width: 100%;
  max-width: var(--headerWidth);
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin: 0 auto;
}
.header-section .header-wrap .brand-logo-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: auto;
}
.header-section .header-wrap .brand-logo-box img {
  width: 100%;
  max-width: 12.813rem;
  height: auto;
}
.header-section .header-wrap .menu-btn {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  background-color: transparent;
  border: 2px solid var(--white-1000);
  border-radius: 50%;
  display: none;
  justify-content: center;
  align-items: center;
  transition: 200ms all ease-in-out;
}
.header-section .header-wrap .menu-btn svg {
  width: 0.875rem;
  height: 0.875rem;
  fill: var(--white-1000);
  transition: 200ms all ease-in-out;
}
.header-section .header-wrap .user-profile-wrap {
  display: none;
  justify-content: flex-end;
  align-items: center;
}
.header-section .header-wrap .navigation-wrap.desktop-navigation-wrap {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 3.5rem;
}
.header-section .header-wrap .navigation-wrap.desktop-navigation-wrap .navigation-box {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4.5rem;
}
.header-section .header-wrap .navigation-wrap.desktop-navigation-wrap .welcome-user {
  color: #fff;
  font-size: large;
  font-weight: 800;
}
.header-section .header-wrap .navigation-wrap.mobile-navigation-wrap {
  display: none;
}
.header-section .header-wrap .nav-link {
  color: var(--white-1000);
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.7;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  display: inline-block;
  transition: 200ms all ease-in-out;
}
.header-section .header-wrap .nav-link:hover, .header-section .header-wrap .nav-link.active {
  color: var(--secondaryMain-1000);
}
.header-section .header-wrap .btn-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.header-section .header-wrap .contact-us-btn {
  min-width: 2.5rem;
  min-height: 2.5rem;
  background-color: var(--secondaryMain-1000);
  border-radius: 0.25rem;
  color: var(--darkCharcoal-1000);
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.7;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  display: inline-block;
  padding: 0.25rem 1rem;
  transition: 200ms all ease-in-out;
}
.header-section .header-wrap .contact-us-btn:hover:not(:disabled) {
  transform: scale(0.95);
  color: var(--darkCharcoal-1000);
}
.header-section .header-wrap .contact-us-btn:active:not(:disabled) {
  transform: scale(0.85);
}
.header-section .header-wrap .contact-us-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.header-section .header-wrap .auth-btn {
  min-width: 2.5rem;
  min-height: 2.5rem;
  border-radius: 0.25rem;
  box-shadow: none;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.7;
  text-transform: uppercase;
  padding: 0.25rem 1rem;
}
.header-section .header-wrap .auth-btn.icon-only {
  width: 2.5rem;
  padding: 0.25rem;
}
.header-section .header-wrap .auth-btn.icon-only svg {
  width: 1.25rem;
  height: 1.25rem;
}
.header-section .header-wrap .user-profile-box {
  min-width: 2.5rem;
  min-height: 2.5rem;
  background-color: var(--secondaryMain-1000);
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  transition: 200ms all ease-in-out;
}
.header-section .header-wrap .user-profile-box .img-box {
  width: 2rem;
  border-radius: 50%;
  aspect-ratio: 1/1;
  overflow: hidden;
}
.header-section .header-wrap .user-profile-box .img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.header-section .header-wrap .user-profile-box .user-name-text {
  color: var(--darkCharcoal-1000);
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.7;
  text-transform: uppercase;
}
@media screen and (max-width: 991.98px) {
  .header-section {
    height: var(--headerHeight);
    aspect-ratio: unset;
    mask-image: unset;
    mask-repeat: unset;
    mask-size: unset;
    padding: 0.5rem 1.25rem 0.5rem;
  }
  .header-section .header-wrap .brand-logo-box img {
    max-width: 8rem;
  }
  .header-section .header-wrap .navigation-wrap.desktop-navigation-wrap {
    gap: 0.875rem;
  }
  .header-section .header-wrap .navigation-wrap.desktop-navigation-wrap .navigation-box {
    gap: 0.875rem;
  }
  .header-section .header-wrap .nav-link {
    font-size: 0.875rem;
  }
  .header-section .header-wrap .btn-box {
    gap: 0.5rem;
  }
  .header-section .header-wrap .contact-us-btn,
  .header-section .header-wrap .auth-btn {
    min-width: 2rem;
    min-height: 2rem;
    font-size: 0.875rem;
    padding: 0.25rem 1rem;
  }
  .header-section .header-wrap .contact-us-btn.icon-only,
  .header-section .header-wrap .auth-btn.icon-only {
    width: 2rem;
    padding: 0.25rem;
  }
  .header-section .header-wrap .contact-us-btn.icon-only svg,
  .header-section .header-wrap .auth-btn.icon-only svg {
    width: 1rem;
    height: 1rem;
  }
  .header-section .header-wrap .user-profile-box {
    min-width: 2rem;
    min-height: 2rem;
  }
  .header-section .header-wrap .user-profile-box .img-box {
    width: 1.375rem;
  }
  .header-section .header-wrap .user-profile-box .user-name-text {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  .header-section {
    padding: 0.5rem 1rem 0.5rem;
  }
  .header-section .header-wrap .brand-logo-box img {
    max-width: 8rem;
  }
  .header-section .header-wrap .menu-btn,
  .header-section .header-wrap .user-profile-wrap {
    display: flex;
  }
  .header-section .header-wrap .navigation-wrap.desktop-navigation-wrap {
    display: none;
  }
  .header-section .header-wrap .navigation-wrap.mobile-navigation-wrap {
    width: 100%;
    max-width: 15rem;
    height: calc(100dvh - var(--headerHeight));
    background-color: var(--white-1000);
    box-shadow: 4px 0px 10px var(--black-250);
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    overflow-y: auto;
    padding: 1rem;
    position: fixed;
    top: var(--headerHeight);
    left: 0;
    transition: 200ms all ease-in-out;
  }
  .header-section .header-wrap .navigation-wrap.mobile-navigation-wrap .navigation-box {
    width: 100%;
    flex-grow: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 0.75rem;
  }
  .header-section .header-wrap .nav-link {
    color: var(--black-1000);
    font-size: 0.875rem;
  }
  .header-section .header-wrap .nav-link:hover, .header-section .header-wrap .nav-link.active {
    color: var(--primaryMain-1000);
  }
  .header-section .header-wrap .contact-us-btn {
    width: 100%;
    font-size: 0.875rem;
  }
  .header-section .header-wrap .auth-btn {
    width: 100%;
    font-size: 0.875rem;
  }
  .header-section .sidebar-backdrop {
    width: 100%;
    height: calc(100dvh - var(--headerHeight));
    background-color: var(--black-500);
    display: block;
    opacity: 0;
    z-index: -1;
    position: fixed;
    top: var(--headerHeight);
    left: 0;
    transition: 200ms all ease-in-out;
  }
  .header-section .sidebar-backdrop.sidebar-backdrop-visible {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderSection.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,2BAAA;EAEA,oCAAA;EAKA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;AAJF;AAME;EACE,WAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAJJ;AAMI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAMM;EACE,WAAA;EACA,oBAAA;EACA,YAAA;AAJR;AAQI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AANN;AAQM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;AANR;AAUI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AARN;AAYM;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAVR;AAYQ;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAVV;AAaQ;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAXV;AAeM;EACE,aAAA;AAbR;AAiBI;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iCAAA;AAfN;AAiBM;EAEE,gCAAA;AAhBR;AAoBI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAlBN;AAqBI;EACE,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iCAAA;AAnBN;AAqBM;EACE,sBAAA;EACA,+BAAA;AAnBR;AAsBM;EACE,sBAAA;AApBR;AAuBM;EACE,YAAA;EACA,mBAAA;AArBR;AAyBI;EACE,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAvBN;AAyBM;EACE,aAAA;EACA,gBAAA;AAvBR;AAyBQ;EACE,cAAA;EACA,eAAA;AAvBV;AA4BI;EACE,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;AA1BN;AA4BM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AA1BV;AA8BM;EACE,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AA5BR;AAiCE;EA/MF;IAgNI,2BAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,8BAAA;EA9BF;EAkCM;IACE,eAAA;EAhCR;EAqCM;IACE,aAAA;EAnCR;EAqCQ;IACE,aAAA;EAnCV;EAwCI;IACE,mBAAA;EAtCN;EAyCI;IACE,WAAA;EAvCN;EA0CI;;IAEE,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,qBAAA;EAxCN;EA0CM;;IACE,WAAA;IACA,gBAAA;EAvCR;EAyCQ;;IACE,WAAA;IACA,YAAA;EAtCV;EA2CI;IACE,eAAA;IACA,gBAAA;EAzCN;EA2CM;IACE,eAAA;EAzCR;EA4CM;IACE,mBAAA;EA1CR;AACF;AA+CE;EAjRF;IAkRI,2BAAA;EA5CF;EAgDM;IACE,eAAA;EA9CR;EAkDI;;IAEE,aAAA;EAhDN;EAqDM;IACE,aAAA;EAnDR;EAsDM;IACE,WAAA;IACA,gBAAA;IACA,0CAAA;IACA,mCAAA;IACA,yCAAA;IACA,aAAA;IACA,2BAAA;IACA,uBAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,wBAAA;IACA,OAAA;IACA,iCAAA;EApDR;EAsDQ;IACE,WAAA;IACA,YAAA;IACA,aAAA;IACA,2BAAA;IACA,uBAAA;IACA,sBAAA;IACA,YAAA;EApDV;EAyDI;IACE,wBAAA;IACA,mBAAA;EAvDN;EAyDM;IAEE,8BAAA;EAxDR;EA4DI;IACE,WAAA;IACA,mBAAA;EA1DN;EA6DI;IACE,WAAA;IACA,mBAAA;EA3DN;EA+DE;IACE,WAAA;IACA,0CAAA;IACA,kCAAA;IACA,cAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,wBAAA;IACA,OAAA;IACA,iCAAA;EA7DJ;EA+DI;IACE,UAAA;EA7DN;AACF","sourcesContent":[".header-section {\n  width: 100%;\n  height: var(--headerHeight);\n  // max-width: var(--headerWidth);\n  background-color: var(--indigo-1000);\n  // aspect-ratio: 772/55;\n  // mask-image: url(../../../public/assets/mask-img/header-bg-mask.svg);\n  // mask-repeat: no-repeat;\n  // mask-size: 100% 100%;\n  z-index: 50;\n  padding: 0.5rem 2.375rem 1rem;\n  margin: 0 auto;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n\n  .header-wrap {\n    width: 100%;\n    max-width: var(--headerWidth);\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem;\n    margin: 0 auto;\n\n    .brand-logo-box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-right: auto;\n\n      img {\n        width: 100%;\n        max-width: 12.813rem;\n        height: auto;\n      }\n    }\n\n    .menu-btn {\n      width: 2rem;\n      min-width: 2rem;\n      height: 2rem;\n      background-color: transparent;\n      border: 2px solid var(--white-1000);\n      border-radius: 50%;\n      display: none;\n      justify-content: center;\n      align-items: center;\n      transition: 200ms all ease-in-out;\n      \n      svg {\n        width: 0.875rem;\n        height: 0.875rem;\n        fill: var(--white-1000);\n        transition: 200ms all ease-in-out;\n      }\n    }\n\n    .user-profile-wrap {\n      display: none;\n      justify-content: flex-end;\n      align-items: center;\n    }\n\n    .navigation-wrap {\n      &.desktop-navigation-wrap {\n        flex-grow: 1;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 3.5rem;\n        \n        .navigation-box {\n          flex-grow: 1;\n          display: flex;\n          justify-content: flex-end;\n          align-items: center;\n          gap: 4.5rem;\n        }\n\n        .welcome-user {\n          color: #fff;\n          font-size: large;\n          font-weight: 800;\n        }\n      }\n\n      &.mobile-navigation-wrap {\n        display: none;\n      }\n    }\n\n    .nav-link {\n      color: var(--white-1000);\n      font-size: 1.125rem;\n      font-weight: 600;\n      line-height: 1.7;\n      text-transform: uppercase;\n      text-decoration: none;\n      text-align: center;\n      display: inline-block;\n      transition: 200ms all ease-in-out;\n\n      &:hover,\n      &.active {\n        color: var(--secondaryMain-1000);\n      }\n    }\n\n    .btn-box {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      gap: 1rem\n    }\n\n    .contact-us-btn {\n      min-width: 2.5rem;\n      min-height: 2.5rem;\n      background-color: var(--secondaryMain-1000);\n      border-radius: 0.25rem;\n      color: var(--darkCharcoal-1000);\n      font-size: 1.125rem;\n      font-weight: 600;\n      line-height: 1.7;\n      text-transform: uppercase;\n      text-decoration: none;\n      text-align: center;\n      display: inline-block;\n      padding: 0.25rem 1rem;\n      transition: 200ms all ease-in-out;\n\n      &:hover:not(:disabled) {\n        transform: scale(0.95);\n        color: var(--darkCharcoal-1000);\n      }\n    \n      &:active:not(:disabled) {\n        transform: scale(0.85);\n      }\n    \n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .auth-btn {\n      min-width: 2.5rem;\n      min-height: 2.5rem;\n      border-radius: 0.25rem;\n      box-shadow: none;\n      font-size: 1.125rem;\n      font-weight: 600;\n      line-height: 1.7;\n      text-transform: uppercase;\n      padding: 0.25rem 1rem;\n\n      &.icon-only {\n        width: 2.5rem;\n        padding: 0.25rem;\n\n        svg {\n          width: 1.25rem;\n          height: 1.25rem;\n        }\n      }\n    }\n\n    .user-profile-box {\n      min-width: 2.5rem;\n      min-height: 2.5rem;\n      background-color: var(--secondaryMain-1000);\n      border-radius: 0.25rem;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.25rem 1rem;\n      transition: 200ms all ease-in-out;\n\n      .img-box {\n        width: 2rem;\n        border-radius: 50%;\n        aspect-ratio: 1/1;\n        overflow: hidden;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          object-position: center;\n        }\n      }\n\n      .user-name-text {\n        color: var(--darkCharcoal-1000);\n        font-size: 1.125rem;\n        font-weight: 600;\n        line-height: 1.7;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    height: var(--headerHeight);\n    aspect-ratio: unset;\n    mask-image: unset;\n    mask-repeat: unset;\n    mask-size: unset;\n    padding: 0.5rem 1.25rem 0.5rem;\n\n    .header-wrap {\n      .brand-logo-box {  \n        img {\n          max-width: 8rem;\n        }\n      }\n\n      .navigation-wrap {\n        &.desktop-navigation-wrap {\n          gap: 0.875rem;\n          \n          .navigation-box {\n            gap: 0.875rem;\n          }\n        }\n      }\n\n      .nav-link {\n        font-size: 0.875rem;\n      }\n\n      .btn-box {\n        gap: 0.5rem\n      }\n\n      .contact-us-btn,\n      .auth-btn {\n        min-width: 2rem;\n        min-height: 2rem;\n        font-size: 0.875rem;\n        padding: 0.25rem 1rem;  \n\n        &.icon-only {\n          width: 2rem;\n          padding: 0.25rem;\n  \n          svg {\n            width: 1rem;\n            height: 1rem;\n          }\n        }\n      }\n\n      .user-profile-box {\n        min-width: 2rem;\n        min-height: 2rem;\n        \n        .img-box {\n          width: 1.375rem;\n        }\n  \n        .user-name-text {\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 0.5rem 1rem 0.5rem;\n    \n    .header-wrap {\n      .brand-logo-box {  \n        img {\n          max-width: 8rem;\n        }\n      }\n\n      .menu-btn,\n      .user-profile-wrap {\n        display: flex;\n      }\n\n\n      .navigation-wrap {\n        &.desktop-navigation-wrap {\n          display: none;\n        }\n\n        &.mobile-navigation-wrap {\n          width: 100%;\n          max-width: 15rem;\n          height: calc(100dvh - var(--headerHeight));\n          background-color: var(--white-1000);\n          box-shadow: 4px 0px 10px var(--black-250);\n          display: flex;\n          justify-content: flex-start;\n          align-items: flex-start;\n          flex-direction: column;\n          gap: 1rem;\n          overflow-y: auto;\n          padding: 1rem;\n          position: fixed;\n          top: var(--headerHeight);\n          left: 0;\n          transition: 200ms all ease-in-out;\n  \n          .navigation-box {\n            width: 100%;\n            flex-grow: 0;\n            display: flex;\n            justify-content: flex-start;\n            align-items: flex-start;\n            flex-direction: column;\n            gap: 0.75rem;\n          }\n        }\n      }\n\n      .nav-link {\n        color: var(--black-1000);\n        font-size: 0.875rem;\n  \n        &:hover,\n        &.active {\n          color: var(--primaryMain-1000);\n        }\n      }\n\n      .contact-us-btn {\n        width: 100%;\n        font-size: 0.875rem;\n      }\n      \n      .auth-btn {\n        width: 100%;\n        font-size: 0.875rem;\n      }\n    }\n\n    .sidebar-backdrop {\n      width: 100%;\n      height: calc(100dvh - var(--headerHeight));\n      background-color: var(--black-500);\n      display: block;\n      opacity: 0;\n      z-index: -1;\n      position: fixed;\n      top: var(--headerHeight);\n      left: 0;\n      transition: 200ms all ease-in-out;\n\n      &.sidebar-backdrop-visible {\n        opacity: 1;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
